import type { Menu } from '@/menus/types.ts';
export default [
  {
    code: 'BASE_DATA_EXPORT_PORT',
    icon: 'menu-export-port',
    label: '出口港',
    path: '/base-data/export-port',
  },
] satisfies Menu[];
